import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import { FiPhone } from "react-icons/fi";
import "./ServicesHowWW.css";
import howWWImage from "../../../../assets/images/services/howww/howw.jpg";
import { resolveMediaUrl } from "../../../../utils/media";

const fallbackHowWW = {
  titleLine1: "How we",
  titleLine2: "work with you",
  note:
    "Reference site about Lorem Ipsum, giving information on its origins, as well as a random Lipsum generator.",
  quoteButtonText: "Get a quote",
  callbackButtonText: "Or request a Call back",
};

const fallbackItems = [
  {
    title: "Consulting",
    text: "Site inspections and technical evaluations to determine the right drywall system for your project — fully aligned with international standards.",
  },
  {
    title: "Purpose",
    text: "Reliable delivery through authorized distributors. Full warranty on products installed according to approved IRQGYP specifications and methods.",
  },
  {
    title: "Deliver",
    text: "Professional training programs — webinars, online sessions, and hands-on workshops — covering products, systems, and best installation practices.",
  },
];

const itemFieldRegex = /^item(\d+)([a-zA-Z0-9_]+)$/i;

const pickString = (...candidates) => {
  for (const c of candidates) {
    if (typeof c === "string" && c.trim()) return c.trim();
  }
  return "";
};

const hasSectionData = (section) => {
  if (!section || typeof section !== "object") return false;
  return Object.values(section).some((value) => {
    if (value === null || typeof value === "undefined") return false;
    if (typeof value === "string") return value.trim().length > 0;
    return true;
  });
};

const tryParseJsonObject = (str) => {
  const t = String(str || "").trim();
  if (!t.startsWith("{") || !t.endsWith("}")) return null;
  try {
    const o = JSON.parse(t);
    return o && typeof o === "object" && !Array.isArray(o) ? o : null;
  } catch {
    return null;
  }
};

const coalesceHowPayload = (raw) => {
  if (raw == null) return null;
  if (typeof raw === "string") return tryParseJsonObject(raw) || null;
  if (typeof raw !== "object") return null;
  let base = { ...raw };
  if (raw.data && typeof raw.data === "object" && !Array.isArray(raw.data)) {
    base = { ...raw, ...raw.data };
  }
  if (typeof raw.value === "string") {
    const parsed = tryParseJsonObject(raw.value);
    if (parsed) base = { ...base, ...parsed };
  } else if (raw.value && typeof raw.value === "object" && !Array.isArray(raw.value)) {
    base = { ...base, ...raw.value };
  }
  return base;
};

const ServicesHowWW = ({ content }) => {
  const section = useMemo(() => {
    const merged = coalesceHowPayload(content);
    return hasSectionData(merged) ? merged : fallbackHowWW;
  }, [content]);

  const items = useMemo(() => {
    const cardsMap = new Map();
    Object.entries(section || {}).forEach(([key, value]) => {
      const match = key.match(itemFieldRegex);
      if (!match) return;
      const index = Number(match[1]);
      const field = String(match[2] || "").replace(/[_\s-]+/g, "").toLowerCase();
      if (!cardsMap.has(index)) cardsMap.set(index, {});
      cardsMap.get(index)[field] = value;
    });

    const mapped = Array.from(cardsMap.entries())
      .sort((a, b) => a[0] - b[0])
      .map(([_, fields], idx) => {
        const fallback = fallbackItems[idx % fallbackItems.length];
        return {
          title: pickString(fields.title, fields.heading) || fallback.title,
          text: pickString(fields.text, fields.description, fields.body) || fallback.text,
        };
      })
      .filter((item) => item.title || item.text);

    return mapped.length ? mapped : fallbackItems;
  }, [section]);

  const imageSrc =
    resolveMediaUrl(
      section.image || section.rightImage || section.heroImage || section.backgroundImage || section.mediaUrl || section.photo
    ) || howWWImage;

  return (
    <section className="servicesHowWW">
      <div className="servicesHowWW-container">
        <h2 className="servicesHowWW-title">
          {pickString(section.titleLine1, section.title, section.heading) || fallbackHowWW.titleLine1}{" "}
          <span>{pickString(section.titleLine2, section.subheading) || fallbackHowWW.titleLine2}</span>
        </h2>

        <div className="servicesHowWW-grid">
          {items.map((item) => (
            <div className="servicesHowWW-card" key={item.title}>
              <h3>{item.title}</h3>
              <p>{item.text}</p>
            </div>
          ))}
        </div>

        <div className="servicesHowWW-imageWrap">
          <img
            src={imageSrc}
            alt="Professional project consultation meeting"
            className="servicesHowWW-image"
            onError={(e) => {
              if (e.currentTarget.src !== howWWImage) {
                e.currentTarget.src = howWWImage;
              }
            }}
          />
        </div>

        {/* <p className="servicesHowWW-note">
          {pickString(section.note, section.noteText, section.footerNote) || fallbackHowWW.note}
        </p> */}

        <div className="servicesHowWW-actions">
          <Link to="/contactus#contact-form" className="servicesHowWW-quoteBtn buttongyp">
            {pickString(section.quoteButtonText, section.cta1Text, section.primaryButtonText) || fallbackHowWW.quoteButtonText}
          </Link>

          <Link to="/contactus#contact-form" className="servicesHowWW-callBtn">
            <span>
              {pickString(section.callbackButtonText, section.cta2Text, section.secondaryButtonText) ||
                fallbackHowWW.callbackButtonText}
            </span>
            <FiPhone className="servicesHowWW-phoneIcon" />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ServicesHowWW;